import { create } from 'zustand'

const melody_track_0 = [70, 60, 63, 79, 82, 63, 48, 55, 58, 60, 63, 79, 84, 63, 84, 70, 70, 60, 63, 79, 82, 63, 48, 55, 58, 60, 63, 79, 84, 63, 84, 70]
const melody_track_1 = [70, 60, 63, 79, 82, 63, 48, 55, 58, 60, 63, 79, 84, 63, 84, 70, 70, 60, 63, 79, 82, 63, 48, 55, 58, 60, 63, 79, 84, 63, 84, 70]
const melody_track_2 = [70, 60, 63, 79, 82, 63, 48, 55, 58, 60, 63, 79, 84, 63, 84, 70, 70, 60, 63, 79, 82, 63, 48, 55, 58, 60, 63, 79, 84, 63, 84, 70]
const melody_track_3 = [70, 60, 63, 79, 82, 63, 48, 55, 58, 60, 63, 79, 84, 63, 84, 70, 70, 60, 63, 79, 82, 63, 48, 55, 58, 60, 63, 79, 84, 63, 84, 70]

const seqStore = create((set) => ({
  
  // SEQUENCE
  melody: [melody_track_0, melody_track_1, melody_track_2, melody_track_3],
  melody_scale: [melody_track_0, melody_track_1, melody_track_2, melody_track_3], //initialize with melody unscaled

  setNote: (track, index, value) =>
    set((state) => {
      const updatedMelody = [...state.melody]
      updatedMelody[track][index] = value
      return { melody: updatedMelody }
    }),

  setNote_scale: (track, index, value) =>
    set((state) => {
      const updatedScaledMelody = [...state.melody_scale]
      updatedScaledMelody[track][index] = value
      return { melody_scale: updatedScaledMelody }
    }),
  

  // SEQUENCE SETTINGS
  settings: {
    maxLength: 16,
    nbrTracks: 4,
    currentTrack: 0,
    mute: [false, false, false, false],
    solo: [false, false, false, false],
    length: [16, 8, 5, 3], 
    semitone: [0, 0, 0, 0], 
    octave: [0, 0, 0, 0],  
    pulses: [16, 16, 16, 16],  
    offset: [0, 0, 0, 0], 
    gatePercentage: [50, 50, 50, 50],
    division: [4, 4, 4, 4],
    direction: [0, 0, 0, 0],
    ratchet: [0, 0, 0, 0],
    root: [0, 0, 0, 0],
    scale: [0, 0, 0, 0],
    midiCh: [0, 1, 2, 3],
    playhead: [0, 0, 0, 0],
    euclideanPattern: [
      [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
      [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
      [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
      [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
    ],
    ratchetPattern: [
      [0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0,],
      [0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0,],
      [0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0,],
      [0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0, 0,0,0,0,]
    ],
  },

  setCurrentTrack: (newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        currentTrack: newValue
      },
    })),

  setMute: (track, newValue) =>
    set((state) => {
      const updatedMute = [...state.settings.mute]
      updatedMute[track] = newValue
      return { settings: {...state.settings, mute: updatedMute}}
    }),
  setSolo: (track, newValue) =>
    set((state) => {
      const updatedSolo = [...state.settings.solo]
      updatedSolo[track] = newValue
      return { settings: {...state.settings, solo: updatedSolo}}
    }),
  
  setLength: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        length: state.settings.length.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setGatePercentage: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        gatePercentage: state.settings.gatePercentage.map((oldValue, index) =>
          index === trackIndex ? newValue : oldValue
        ),
      },
    })),

  setSemitone: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        semitone: state.settings.semitone.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setOctave: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        octave: state.settings.octave.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setPulses: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        pulses: state.settings.pulses.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setOffset: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        offset: state.settings.offset.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setDivision: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        division: state.settings.division.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setDirection: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        direction: state.settings.direction.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setRatchet: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        ratchet: state.settings.ratchet.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setMidiCh: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        midiCh: state.settings.midiCh.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setPlayhead: (trackIndex, newValue) =>
    set((state) => ({
      ...state,
      settings: {
        ...state.settings,
        playhead: state.settings.playhead.map((oldValue, index) => (index === trackIndex ? newValue : oldValue)),
      },
    })),

  setEuclideanPattern: (track, newValue) =>
    set((state) => {
      const updatedEuclideanPattern = [...state.settings.euclideanPattern]
      updatedEuclideanPattern[track] = newValue
      return {settings: {...state.settings, euclideanPattern: updatedEuclideanPattern}}
    }),

  setRatchetPattern: (track, index, newValue) =>
    set((state) => {
      const updatedPattern = [...state.settings.ratchetPattern]
      updatedPattern[track][index] = newValue
      return { settings: { ...state.settings, ratchetPattern: updatedPattern } }
    }),

  setScale: (track, newValue) =>
    set((state) => {
      const updatedScale = [...state.settings.scale]
      updatedScale[track] = newValue
      return { settings: {...state.settings, scale: updatedScale}}
    }),

  setRoot: (track, newValue) =>
    set((state) => {
      const updatedRoot = [...state.settings.root]
      updatedRoot[track] = newValue
      return { settings: {...state.settings, root: updatedRoot}}
    }),
  
  // TEMPO
  tempo: Number(120),
  
  setTempo: (newValue) => {
    set(() => ({
      tempo: newValue
    }))
  },

  setSettings: (newValue) => {
    set((state) => ({
      settings: {...state.settings, ...newValue}
    }))
  }, 

  setMelody: (index, newValue) => 
    set((state) => ({
      melody: state.melody.map((oldValue, i) => (i === index ? newValue : oldValue)),
    })),

  setMelody_scale: (index, newValue) => {
    set((state) => ({
      melody_scale: state.melody_scale.map((oldValue, i) => (i === index ? newValue : oldValue)),
    }))
  }, 

}))



export default seqStore